import React, { useRef, useState } from 'react';
import { createStateMachine, MachineConfig } from './createStateMachine';
import Step1 from './comps/Step1';
import Step2 from './comps/Step2';
import Step3 from './comps/Step3';
import Step4 from './comps/Step4';
import Step5 from './comps/Step5';
import Form from './comps/Form';
import NotQualified from './comps/NotQualified';
import css from './index.module.scss';
import Disclaimer from './comps/Disclaimer';
import FormSuccess from './comps/FormSuccess';

type State = 'step1' | 'step2' | 'step3' | 'step4' | 'step5' | 'disclaimer' | 'form' | 'formSuccess' | 'notQualified';
/** 每个 step 通过 send 第二个参数追加到 context.answers 的项 */
export type StepAnswerItem = Record<string, unknown>;

export type RemoteInstallFormContext = {
    step1: 'yes' | 'no';
    step2: 'yes' | 'no';
    step3: 'yes' | 'no';
    step4: 'unsure' | 'electricians' | 'my';
    step5: 'has' | 'only' | 'not';
    /** 各 step 按钮 send 时传入的第二个参数会依次推入此数组 */
    answers: StepAnswerItem[];
};

// 流程
const surveyConfig: MachineConfig<RemoteInstallFormContext, State, any> = {
    initial: 'form',
    states: {
        step1: {
            component: Step1, // step1 组件内容
            on: {
                yes: 'notQualified', // 选项 yes 跳 notQualified
                no: 'step2', // 选项 no 跳 step2
            },
        },
        step2: {
            component: Step2,
            on: {
                yes: 'notQualified',
                no: 'step4',
            },
        },
        step3: {
            component: Step3,
            on: {
                yes: 'step4',
                no: 'notQualified',
            },
        },
        step4: {
            component: Step4,
            on: {
                unsure: 'notQualified',
                electricians: 'disclaimer',
                my: 'step5',
            },
        },
        step5: {
            component: Step5,
            on: {
                has: 'disclaimer',
                only: 'notQualified',
                not: 'notQualified',
            },
        },
        disclaimer: {
            component: Disclaimer,
            on: {
                next: 'form',
            },
        },
        form: {
            component: Form,
            on: {
                done: 'formSuccess',
            },
        },
        formSuccess: {
            component: FormSuccess,
        },
        notQualified: {
            component: NotQualified,
        },
    },
};

const RemoteInstallForm: React.FC = ({}) => {
    // 创建状态机实例（context 含 answers 数组，用于收集各 step 的答案对象）
    const machineRef = useRef(createStateMachine(surveyConfig, { answers: [] } as unknown as RemoteInstallFormContext));
    const machine = machineRef.current;

    // React 用于重新渲染
    const [state, setState] = useState(machine.state);

    const send = (event: string, answer?: StepAnswerItem) => {
        const payload = event === 'BACK' || event === 'BACK2' ? undefined : ({ [machine.state]: event, _answer: answer } as Record<string, unknown>);
        machine.send(event as Parameters<typeof machine.send>[0], payload);
        setState(machine.state); // 更新渲染
        window.scrollTo({ behavior: 'instant', top: 0 });
    };

    // 获取当前状态对应组件
    const Component = surveyConfig.states[state].component as React.ComponentType<any>;

    return (
        <div className={css.container}>
            <Component send={send} context={machine.context} />
        </div>
    );
};
export default RemoteInstallForm;
